import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  DialogProps
} from '@mui/material';
import { CloseIcon } from '@components/icons/svg-icon.tsx';
import { AppDialogProps } from '@models/app-dialog.model.ts';

const AppDialog: React.FC<AppDialogProps> = ({
  open,
  title,
  content,
  actions,
  onClose,
  size = 'md',
  width,
  disableBackdropClick = false,
  titleAlign = 'start'
}) => {
  const handleClose: DialogProps['onClose'] = (_, reason) => {
    if (
      disableBackdropClick &&
      (reason === 'backdropClick' || reason === 'escapeKeyDown')
    ) {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={size}
      disableEscapeKeyDown={disableBackdropClick}
      aria-hidden={'false'}
      sx={width ? { '& .MuiDialog-paper': { maxWidth: width } } : undefined}
    >
      {title && (
        <DialogTitle
          sx={{
            textAlign: titleAlign
          }}
        >
          {title}
        </DialogTitle>
      )}
      <IconButton
        className="p-0! absolute! top-3 right-3 max-lg-xl:w-10! h-10! z-10"
        onClick={onClose}
      >
        <CloseIcon className="max-lg-xl:w-4.5!" />
      </IconButton>
      <DialogContent>{content}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default AppDialog;
